<template>
    <div class="totalReport wrapper">
        <proTitle></proTitle>
        <div class="create-bar">
            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="createReport">新建报告</el-button>
        </div>
        <el-form :inline="true" class="demo-form-inline" @submit.native.prevent>
            <div class="formInline-left">
                <el-form-item>
                    <el-select v-model="filters.templateId" size="medium" clearable placeholder="全部类型"
                        style="width: 180px" @change="onFilterChange">
                        <el-option v-for="item in templates" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.genStatus" size="medium" clearable placeholder="全部状态"
                        style="width: 140px" @change="onFilterChange">
                        <el-option v-for="item in genStatusOptions" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.publishStatus" size="medium" clearable placeholder="全部发布状态"
                        style="width: 150px" @change="onFilterChange">
                        <el-option v-for="item in publishStatusOptions" :key="item.value" :label="item.label"
                            :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="filters.name" size="medium" clearable placeholder="搜索报告名称"
                        suffix-icon="el-icon-search" @input="onSearchInput" @clear="onFilterChange" />
                </el-form-item>
            </div>
        </el-form>
        <div class="table_section" v-loading="loading">
            <template v-if="tableData.length">
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column label="序号" width="70" align="center" type="index" :index="indexMethod" />
                    <el-table-column prop="name" label="报告名称" align="center" min-width="160" show-overflow-tooltip />
                    <el-table-column label="报告类型" align="center" min-width="140" show-overflow-tooltip>
                        <template slot-scope="{ row }">
                            <el-tag size="small" :type="row.category === 'personal' ? '' : 'success'">
                                {{ row.templateName || "—" }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="数据范围" align="center" min-width="180" show-overflow-tooltip>
                        <template slot-scope="{ row }">{{ scopeText(row) }}</template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" width="100">
                        <template slot-scope="{ row }">
                            <el-tooltip v-if="row.failReason" :content="row.failReason" placement="top">
                                <el-tag size="small" :type="genTag(row.genStatus)">
                                    {{ genLabel(row) }}
                                </el-tag>
                            </el-tooltip>
                            <el-tag v-else size="small" :type="genTag(row.genStatus)">{{ genLabel(row) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="发布状态" align="center" width="100">
                        <template slot-scope="{ row }">
                            <el-tag size="small" :type="row.publishStatus === 'published' ? 'success' : 'info'">
                                {{ publishLabel(row) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="生成时间" align="center" width="160" />
                    <el-table-column label="操作" align="center" width="280" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button type="text" size="small" @click="openWizard('view', row)">查看</el-button>
                            <el-button type="text" size="small" @click="openRename(row)">编辑基本信息</el-button>
                            <el-button type="text" size="small" @click="openWizard('edit', row)">编辑报告</el-button>
                            <br>
                            <el-button type="text" size="small" :disabled="row.publishStatus !== 'published'"
                                @click="unpublish(row)">取消发布</el-button>
                            <el-button type="text" size="small" @click="remove(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :total="pages.total" :page.sync="pages.currentPage" :limit.sync="pages.pageSize"
                    :pageSizes="[10, 20, 30]" @pagination="handlePageChange" />
            </template>
            <el-empty v-else description="暂无报告，请点击「新建报告」开始生成" />
        </div>

        <el-dialog title="编辑基本信息" :visible.sync="renameVisible" width="440px" @closed="renameRow = null">
            <el-form label-width="90px" @submit.native.prevent>
                <el-form-item label="报告名称" required>
                    <el-input v-model.trim="renameName" maxlength="100" placeholder="请输入报告名称" />
                </el-form-item>
            </el-form>
            <p class="rename-hint">仅可修改报告名称，其他信息请通过「编辑报告」调整</p>
            <span slot="footer">
                <el-button @click="renameVisible = false">取消</el-button>
                <el-button type="primary" :loading="renameLoading" @click="saveRename">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        GEN_STATUS_OPTIONS,
        PUBLISH_STATUS_OPTIONS,
        formatScope,
        genStatusLabel,
        genStatusTag,
        publishStatusLabel,
    } from "./shared";

    export default {
        name: "reportV2List",
        data() {
            return {
                loading: false,
                tableData: [],
                templates: [],
                scopeOptions: {
                    stages: [],
                    userGroups: [],
                    areas: [],
                    cycles: [],
                    homeworks: [],
                },
                filters: {
                    templateId: "",
                    genStatus: "",
                    publishStatus: "",
                    name: "",
                },
                pages: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                genStatusOptions: GEN_STATUS_OPTIONS,
                publishStatusOptions: PUBLISH_STATUS_OPTIONS,
                searchTimer: null,
                renameVisible: false,
                renameLoading: false,
                renameName: "",
                renameRow: null,
            };
        },
        computed: {
            projectId() {
                return this.$store.state.user.currentProject.id;
            },
        },
        mounted() {
            this.loadOptions();
            this.getList();
        },
        beforeDestroy() {
            if (this.searchTimer) clearTimeout(this.searchTimer);
        },
        methods: {
            indexMethod(index) {
                return this.pages.currentPage > 1
                    ? (this.pages.pageSize * (this.pages.currentPage - 1)) + index + 1
                    : index + 1;
            },
            genLabel(row) {
                return genStatusLabel(row.genStatus, row.genStatusLabel);
            },
            genTag(status) {
                return genStatusTag(status);
            },
            publishLabel(row) {
                return publishStatusLabel(row.publishStatus, row.publishStatusLabel);
            },
            scopeText(row) {
                return formatScope(row.scope, this.scopeOptions, row.dataType);
            },
            onFilterChange() {
                this.pages.currentPage = 1;
                this.getList();
            },
            onSearchInput() {
                if (this.searchTimer) clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(() => {
                    this.onFilterChange();
                }, 300);
            },
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex;
                this.pages.pageSize = data.pageSize;
                this.getList();
            },
            async loadOptions() {
                const projectId = this.projectId;
                try {
                    const [tplRes, scopeRes] = await Promise.all([
                        this.$Api.ReportV2.getTemplates({ projectId }),
                        this.$Api.ReportV2.getScopeOptions({ projectId }),
                    ]);
                    if (tplRes && tplRes.code == 200) {
                        const data = tplRes.data || {};
                        this.templates = data.rows || data || [];
                        if (!Array.isArray(this.templates)) this.templates = [];
                    }
                    if (scopeRes && scopeRes.code == 200 && scopeRes.data) {
                        this.scopeOptions = Object.assign({}, this.scopeOptions, scopeRes.data);
                    }
                } catch (e) {
                    this.$message.error("筛选项加载失败");
                }
            },
            async getList() {
                this.loading = true;
                const params = {
                    projectId: this.projectId,
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                };
                if (this.filters.templateId) params.templateId = this.filters.templateId;
                if (this.filters.genStatus) params.genStatus = this.filters.genStatus;
                if (this.filters.publishStatus) params.publishStatus = this.filters.publishStatus;
                if (this.filters.name) params.name = this.filters.name;
                try {
                    const res = await this.$Api.ReportV2.getList(params);
                    if (!res || res.code != 200) {
                        this.$message.error((res && res.msg) || "报告列表加载失败");
                        this.tableData = [];
                        this.pages.total = 0;
                        return;
                    }
                    const data = res.data || {};
                    this.tableData = data.rows || [];
                    this.pages.total = data.total || 0;
                } catch (e) {
                    this.$message.error("报告列表加载失败");
                } finally {
                    this.loading = false;
                }
            },
            createReport() {
                this.$router.push({ path: "/home/totalReportV2", query: { mode: "create" } });
            },
            openWizard(mode, row) {
                this.$router.push({
                    path: "/home/totalReportV2",
                    query: { mode, id: row.id },
                });
            },
            openRename(row) {
                this.renameRow = row;
                this.renameName = row.name || "";
                this.renameVisible = true;
            },
            async saveRename() {
                if (!this.renameName) {
                    this.$message.warning("请输入报告名称");
                    return;
                }
                this.renameLoading = true;
                try {
                    const res = await this.$Api.ReportV2.rename({
                        id: this.renameRow.id,
                        name: this.renameName,
                    });
                    if (!res || res.code != 200) {
                        this.$message.error((res && res.msg) || "保存失败");
                        return;
                    }
                    this.$message.success("基本信息已保存");
                    this.renameVisible = false;
                    this.getList();
                } catch (e) {
                    this.$message.error("保存失败");
                } finally {
                    this.renameLoading = false;
                }
            },
            unpublish(row) {
                if (row.publishStatus !== "published") return;
                this.$confirm("确认取消发布该报告？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(async () => {
                    try {
                        const res = await this.$Api.ReportV2.unpublish({ id: row.id });
                        if (!res || res.code != 200) {
                            this.$message.error((res && res.msg) || "取消发布失败");
                            return;
                        }
                        this.$message.success("已取消发布");
                        this.getList();
                    } catch (e) {
                        this.$message.error("取消发布失败");
                    }
                }).catch(() => { });
            },
            remove(row) {
                this.$confirm(`确认删除名为“${row.name}”的报告？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(async () => {
                    try {
                        const res = await this.$Api.ReportV2.deleteReport({ id: row.id });
                        if (!res || res.code != 200) {
                            this.$message.error((res && res.msg) || "删除失败");
                            return;
                        }
                        this.$message.success("已删除");
                        this.getList();
                    } catch (e) {
                        this.$message.error("删除失败");
                    }
                }).catch(() => { });
            },
        },
    };
</script>

<style lang="less" scoped>
    @import "../../manage/less/table.less";

    .totalReport {
        padding: 20px 25px;
        box-sizing: border-box;

        .table_section {
            margin-top: 15px;
        }

        .create-bar {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 12px;
        }
    }

    .rename-hint {
        margin: 0;
        font-size: 12px;
        color: #909399;
    }
</style>
